import { ORDER_FULFILLMENT_STATUSES } from '../../../../../services/exports/Constants';

export default {
  title: '{{orderMethod}} estimado: {{day}} por volta das {{time}}',
  status: {
    [ORDER_FULFILLMENT_STATUSES.REJECTED]: {
      title: 'Pedido rejeitado',
    },
    [ORDER_FULFILLMENT_STATUSES.CREATED]: {
      title: 'Pedido recebido',
    },
    [ORDER_FULFILLMENT_STATUSES.REVIEWED]: {
      title: 'O seu pedido foi visto',
    },
    [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: {
      title: 'Pedido confirmado',
    },
    [ORDER_FULFILLMENT_STATUSES.READY]: {
      title: 'Pedido pronto',
    },
    [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: {
      title: 'Pedido em entrega',
    },
    [ORDER_FULFILLMENT_STATUSES.PICKED]: {
      title: 'Pedido concluído',
    },
  },
  labels: {
    today: 'Hoje',
  },
  waiting_confirmation: {
    title: 'A aguardar confirmação do pedido',
    description: 'Aguarde...',
  },
  pickup_time: {
    title: 'Hora de levantamento',
    description: 'Confirmado por {{name}}',
  },
  delivery_time: {
    title: 'Hora de entrega',
    description: 'Confirmado por {{name}}',
  },
  warning_label: {
    pickup_time_changed: '{{company}} alterou a hora de {{initialTime}} para {{currentTime}}',
  },
};
